/**
 * Schema.org JSON-LD payloads.
 * NOTE: No 501(c)(3), taxID, or tax-exempt fields anywhere — by design.
 */

const SITE_URL = "https://vibeforsuccess.org";

export const ORG_SCHEMA = {
    "@context": "https://schema.org",
    "@type": ["NonprofitOrganization", "EducationalOrganization"],
    name: "Vibe for Success, Inc.",
    alternateName: "Vibe for Success",
    url: SITE_URL,
    logo: `${SITE_URL}/logo.png`,
    description:
        "Vibe for Success, Inc. is a Florida nonprofit corporation helping Lee County, Florida high school students build AI-era workforce readiness through creative, hands-on digital skills training.",
    foundingDate: "2026",
    founder: { "@type": "Person", name: "Samantha Sims" },
    areaServed: {
        "@type": "AdministrativeArea",
        name: "Lee County, Florida",
    },
    email: "mailto:hello@vibeforsuccess.org",
    sameAs: [],
};

export const COURSE_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "Course",
    name: "Future Builders Lab",
    description:
        "A 6-week creative workforce-readiness pilot program where Lee County, Florida high school students build safe, parent-approved personal portfolio websites using AI-assisted web tools, light HTML/CSS, and digital safety practices.",
    provider: {
        "@type": "NonprofitOrganization",
        name: "Vibe for Success, Inc.",
        url: SITE_URL,
    },
    educationalLevel: "High school",
    audience: {
        "@type": "EducationalAudience",
        educationalRole: "student",
    },
    inLanguage: "en",
    isAccessibleForFree: true,
    offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
        category: "Free (sponsored seats)",
        availability: "https://schema.org/PreOrder",
    },
    hasCourseInstance: {
        "@type": "CourseInstance",
        courseMode: "in-person",
        courseWorkload: "PT2H",
        duration: "P6W",
        location: {
            "@type": "Place",
            name: "Lee County, Florida — North Fort Myers / Cape Coral focus",
        },
    },
};
